import React from 'react';
import { IIconProps } from './utils';

export const MoreMenuVertical = ({
  fill = 'currentColor', height = 15, ...rest
}: IIconProps) => {
  const heightInt = typeof height === 'string' ? parseInt(height, 10) : height;

  return (
    <svg
      fill="none"
      height={heightInt}
      viewBox="0 0 4 12"
      width={heightInt / 3}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d={`M0.832682 1.33366C0.832682 1.97799 1.35502 2.50033 1.99935 2.50033C2.64368
            2.50033 3.16602 1.97799 3.16602 1.33366C3.16602 0.689327 2.64368 0.166992
            1.99935 0.166992C1.35502 0.166992 0.832682 0.689327 0.832682 1.33366Z`}
        fill={fill}
      />
      <path
        d={`M0.832682 6.00033C0.832682 6.64466 1.35502 7.16699 1.99935 7.16699C2.64368
            7.16699 3.16602 6.64466 3.16602 6.00033C3.16602 5.35599 2.64368 4.83366
            1.99935 4.83366C1.35502 4.83366 0.832682 5.35599 0.832682 6.00033Z`}
        fill={fill}
      />
      <path
        d={`M0.832682 10.667C0.832682 11.3113 1.35502 11.8337 1.99935 11.8337C2.64368
            11.8337 3.16602 11.3113 3.16602 10.667C3.16602 10.0227 2.64368 9.50033
            1.99935 9.50033C1.35502 9.50033 0.832682 10.0227 0.832682 10.667Z`}
        fill={fill}
      />
    </svg>
  );
};
